import React from 'react'
import clsx from 'clsx'
import { IconButton, MenuProps as MUIMenuProps } from '@mui/material'
import { CloseCircle } from 'iconsax-react'

import useStyles, { StyledMenu } from './styles'

type MenuProps = {
  children: React.ReactNode
  className?: string
  optionsComponent: React.ReactNode
  title?: string
  closeOnClick?: boolean
  menuProps?: Omit<MUIMenuProps, 'open'>
  disabled?: boolean
  hideHeader?: boolean
  onVisibilityChange?: (visibile: boolean) => void
  menuClassName?: string
  disablePadding?: boolean
}

const Menu: React.FC<MenuProps> = ({
  children,
  className,
  optionsComponent,
  title,
  closeOnClick = false,
  menuProps = {},
  disabled,
  hideHeader,
  onVisibilityChange,
  menuClassName,
  disablePadding
}) => {
  const [anchor, setAnchor] = React.useState(null)

  const classes = useStyles({ disablePadding })

  React.useEffect(() => {
    onVisibilityChange && onVisibilityChange(Boolean(anchor))
  }, [onVisibilityChange, anchor])

  const handleOpen = e => {
    if (!disabled) {
      e.stopPropagation()
      setAnchor(e.currentTarget)
    }
  }

  const handleClose = e => {
    e.stopPropagation()
    setAnchor(null)
  }

  const handleClick = () => {
    if (closeOnClick) {
      setAnchor(null)
    }
  }

  return (
    <>
      <div className={clsx(classes.root, className)} onClick={handleOpen}>
        {children}
      </div>

      {Boolean(anchor) && (
        <StyledMenu
          anchorEl={anchor}
          open={Boolean(anchor)}
          onClose={handleClose}
          onClick={handleClick}
          className={menuClassName}
          {...menuProps}
        >
          <div className={classes.children}>
            {!hideHeader && (
              <>
                <div className={classes.title}>{title}</div>

                <IconButton className={classes.close} onClick={handleClose}>
                  <CloseCircle />
                </IconButton>
              </>
            )}

            <div className={classes.options}>{optionsComponent}</div>
          </div>
        </StyledMenu>
      )}
    </>
  )
}

export default Menu
